export default [
  {
    path: '/keuangan/penghasilan',
    name: 'penghasilan',
    component: () => import('@/views/pages/komship/keuangan/Penghasilan.vue'),
    meta: {
      name: 'penghasilan',
      resource: 'Penghasilan',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Penghasilan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/saldo',
    name: 'saldo',
    component: () => import('@/views/pages/komship/keuangan/Saldo'),
    meta: {
      name: 'saldo',
      resource: 'Saldo',
      routeToRincianSaldo: 'saldo-detail',
      routeToOrder: 'data-order',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Saldo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/saldo/detail',
    name: 'saldo-detail',
    component: () => import('@/views/pages/komship/keuangan/DetailSaldo.vue'),
    meta: {
      name: 'saldo',
      resource: 'Saldo Detail',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Saldo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/saldo/rincian/:id',
    name: 'rincian-penarikan',
    component: () => import('@/views/pages/komship/keuangan/RincianPenarikan.vue'),
    meta: {
      name: 'saldo',
      resource: 'Saldo',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Saldo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/saldo/detail/fulfillment',
    name: 'detail-fulfillment',
    component: () => import('@/views/pages/kompack/keuangan/DetailFulfillment.vue'),
    meta: {
      name: 'saldo',
      resource: 'Saldo',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Saldo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/saldo/detail/fulfillment-kompack',
    name: 'detail-fulfillment-kompack',
    component: () => import('@/views/pages/kompack/packing/history/detail/DetailPacking.vue'),
    meta: {
      name: 'saldo',
      resource: 'Saldo',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Saldo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/riwayat-penarikan/low-moving-stock/:id',
    name: 'detail-low-moving-stock',
    component: () => import('@/views/pages/kompack/low-moving-stock/Detail'),
    meta: {
      name: 'saldo',
      resource: 'Saldo',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Saldo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/tagihan',
    name: 'tagihan',
    component: () => import('@/views/pages/keuangan/tagihan/Tagihan'),
    meta: {
      name: 'tagihan',
      resource: 'Tagihan',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Tagihan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/keuangan/tagihan/:id',
    name: 'tagihan-detail',
    component: () => import('@/views/pages/keuangan/tagihan/Detail'),
    meta: {
      name: 'tagihan',
      resource: 'Tagihan',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Tagihan',
          active: true,
        },
      ],
    },
  },
]
